/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import publicPath from '../../utils/publicPath';
import { LoadingLocation } from '../Icons';
import Image from '../Image';
import Text from '../Text';
import useStyles from './styles';

const LoaderWhite = forwardRef(({ message, inline, isOnboarding, isSmall,  ...rest }, ref) => {
  const styles = useStyles();

  const labelId = 'spinning-loader-text';

  //isOnboarding is to display ef spinning logo at the end of onboarding
  return (
    <div {...rest}>
      {isOnboarding === 'false' ? (
        <LoadingLocation />
      ) : (
        <div css={styles.loaderDiv}>
          <div css={styles.loaderCircle(isSmall)}>
            <Image
              src={publicPath(`/images/common/loader-circle-icon.png`)}
              alt="Loader icon"
            />
          </div>
          <div css={styles.logoImage(isSmall)}>
            <Image
              src={publicPath(`/images/common/loader-ef-logo.svg`)}
              alt="Loader icon"
            />
          </div>
        </div>
      )}
      <Text
        role="text"
        size={6}
        id={labelId}
        css={styles.text(!!message, inline)}
        tabIndex={-1}
        ref={ref}
      >
        {message || 'Loading'}
      </Text>
    </div>
  );
});

LoaderWhite.propTypes = {
  message: PropTypes.string,
  inline: PropTypes.bool,
  isOnboarding: PropTypes.bool,
};

export default LoaderWhite;
